import axios from "axios";
import { awsUrl, aspNetUrl } from "../../axiosInstance";

export const GetMosadDetails = () => {
  console.log(
    "*****************************:,",
    localStorage.jwtToken,
    "jwtToken",
  );
  return axios.get(`${awsUrl}/v1/nedarim/details`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const Payment = (data) => {
  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return axios.post(`${aspNetUrl}Payment/TranzilaPayCard`, data, { headers });
  console.log("TranzilaPayCard called: OrderId={tranzilaPayModel.OrderId}");
};

export const SavePaymentNedarim = (data) => {
  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
  };
  return axios.post(`${awsUrl}/v1/payment/nedarim`, data, { headers });
};

export const SavePaymen = (data) => {
  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return axios.post(`${aspNetUrl}Payment/SavePaymen`, data, { headers });
};

export const GetPaymentPerOrder = (orderId) => {
  return axios.get(`${aspNetUrl}Payment/GetPayment?OrderId=${orderId}`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const SaveNedarimData = (data, orderId, tokenId) => {
  const payload = {
    ...data,
    OrderId: orderId,
    PaymentNedarimTokenId: tokenId,
    StatusPay: 1,
  };

  const headers = {
    Authorization: `bearer ${localStorage.jwtToken}`,
  };

  return axios.post(`${awsUrl}/v1/payment`, payload, { headers });
};
